import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DetailReportComponent } from './detail-report/detail-report.component';

const routes: Routes = [
  // { path: '', redirectTo: '../../../error/404' },
  { path:'overall-report',component:DetailReportComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
